import React, { useEffect, useState } from 'react'

import collapsed from './../../../UI/general/collapse.svg'
import close from "./../../../UI/general/close.svg"
import next from "./../../../UI/general/Next-Asset.svg"

import gallery from "./../../../UI/Modal/gallery.svg"

/*eslint-disable */

interface BrochuresComponentProps {
    isBrochureActive: boolean,
    amenityData: any,
    handleCloseBrochure: any,
    colorsData: any,
    galleryName: string,
    breadCrumbs: any,
    handleGetBreadCrumbSelected: any,
    comesFromModalGallery: boolean
}

const BrochuresComponent = ({
    isBrochureActive,
    amenityData,
    handleCloseBrochure,
    colorsData,
    galleryName,
    breadCrumbs,
    handleGetBreadCrumbSelected,
    comesFromModalGallery
}: BrochuresComponentProps) => {

    const [isCollapsed, setIsCollapsed] = useState(!comesFromModalGallery)
    const [currentSelectedBrochure, setCurrentSelectedBrochure] = useState("")
    const [currentSelectedBrochureIndex, setCurrentSelectedBrochureIndex] = useState(0)
    const [rgbaColor, setRGBAColor] = useState({})
    const [show,setShow] = useState(false)

    useEffect(() => {
        if(isBrochureActive && amenityData){
            setCurrentSelectedBrochure(amenityData.links[0].link)
            var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(colorsData.main_buttons)
            setRGBAColor(result ? {r:  parseInt(result[1], 16), g: parseInt(result[2], 16), b: parseInt(result[3], 16)}:'')
            setIsCollapsed(breadCrumbs.length === 0)
            /*if(isCollapsed){
                setTimeout(() => {
                    setIsCollapsed(false)
                }, 500)
            }*/
            setShow(true)
        }
    }, [])

    

    const handleChangeTour = (tour: any, index: number) => {
        setCurrentSelectedBrochure(tour)
        setCurrentSelectedBrochureIndex(index)
    }

    return(
        <React.Fragment>
            <div 
            className={show ? 'brochure-container fade-in':'brochure-container fade-out'}
        >
            {
                isBrochureActive ?
                <div className={isCollapsed ? 'brochure-container-wide':'brochure-container-files'}>
                    <div className='brochure-container-file'>
                        <embed src={currentSelectedBrochure}/>
                    </div>
                </div>:null
            }
            <div
                className={isCollapsed ? 'sidebar-brochure-btn-collapsed':'sidebar-brochure-btn'}
                onClick = {() => {
                    setIsCollapsed(!isCollapsed)
                }}
            >
                <img src={collapsed} alt=""/>
            </div>
            <div 
                className={isCollapsed ? 'sidebar-brochure-container-collapsed':'sidebar-brochure-container'}
            >
                <div 
                    className="general-gallery-close-container"
                    onClick={() => {
                        setIsCollapsed(true)
                        setTimeout(() => {
                            handleCloseBrochure()
                        }, 500)
                    }}
                >
                    <img src={close} alt=''/>
                </div>
                {
                    galleryName !== '' && breadCrumbs.length === 0 ?
                    <div className='gallery-modal-name'
                    onClick={
                            breadCrumbs.length > 0 ?
                            () => {
                                handleGetBreadCrumbSelected(-1)
                            }:() => {}
                        }
                    style={{
                        cursor: breadCrumbs.length > 0 ? 'pointer':'inherti'
                    }}
                    >{breadCrumbs.length > 0 ? 'Galería':galleryName}</div>:null
                }
                {
                    galleryName !== '' && breadCrumbs.length > 0 ?
                    <React.Fragment>
                        <div className='general-gallery-img-icon-container'>
                            <img src={gallery} alt=''/>
                        </div>
                        <div className='galerry-name-desktop'>GALERÍA</div>
                    </React.Fragment>:null
                }
                {
                    breadCrumbs.length > 0 ?
                    <div className='breadcrumbs-gallery-modal-container-desktop'>
                        <div className='breadcrumb' onClick={() => {
                            handleGetBreadCrumbSelected(-1)
                        }}>Galería</div>
                        {
                            breadCrumbs.map((breadCrumb :any, index: number) => 
                            <React.Fragment>
                                <img src={next} alt=''/>
                                <div 
                                    className={index === breadCrumbs.length - 1 ? 'last-breadcrumb':'breadcrumb'} 
                                    onClick={index === breadCrumbs.length -1 ? () => {}:() => {handleGetBreadCrumbSelected(index)}}
                                    style={{
                                        backgroundColor: index === breadCrumbs.length -1 ? colorsData.main_buttons:'#none',
                                        animation: index === breadCrumbs.length -1 ? 'moveLeftAlt 0.4s ease-in-out 1':'none'
                                    }}
                                >
                                    {breadCrumb}
                                </div>
                            </React.Fragment>
                            )
                        }
                    </div>:null
                }
                <div className='sidebar-tour-preview-container-brochures' style={{
                    top: breadCrumbs.length > 0 ? '23%':'10%', 
                    height: breadCrumbs.length > 0 ? '77%':'90%',
                    animation: 'moveLeft 1s ease-in-out 1'
                    }}>
                {
                            amenityData && amenityData.links ?
                            amenityData.links.map((tours: any, index: number) => 
                                <div 
                                    className='individual-tour-container-alt'
                                    onClick = {() => {
                                        handleChangeTour(tours.link, index)
                                    }}
                                    style={{
                                        boxSizing: 'border-box',
                                        backgroundColor: currentSelectedBrochureIndex === index ? colorsData.main_buttons:'transparent',
                                        color: currentSelectedBrochureIndex === index ? colorsData.secondary_text:colorsData.main_text
                                    }}
                                >
                                    <div 
                                        className='individual-tour-name-container-alt'
                                    >
                                        {tours.name}
                                    </div>
                                </div>
                            ):null
                        }
                </div>
            </div>
        </div>
        </React.Fragment>
    )
}

export default BrochuresComponent